import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { formatDate } from '../../../getDeadline.js';
import partnerPropTypes from '../../../partnerPropTypes.js';
import { data as paymentDataPropTypes } from '../../../paymentPropTypes.js';
import Page from '../../../page.jsx';

const PaymentDelayedDetails = ({ partner, payment }) => (
    <Page heading={`${partner.name} har ikke fått varen`}>
        <div>
            <p>
                Vi har utsatt din betaling til{' '}
                <span className="strong">
                    {formatDate(payment.automaticApprove)}
                </span>.
            </p>
            <p>
                Send varen fortest mulig til {partner.name}, og gi gjerne
                beskjed om at den er på vei.
            </p>

            <div className="centerify">
                <div className="r-pal">
                    <Link to="/samtale" className="button fullwidth">
                        OK, den er grei
                    </Link>
                </div>
                <div className="r-mvm">
                    <Link to="/hev-avtale" className="pam">
                        Hev kjøpet
                    </Link>
                </div>
            </div>
        </div>
    </Page>
);

PaymentDelayedDetails.propTypes = {
    partner: partnerPropTypes.isRequired,
    payment: paymentDataPropTypes.isRequired,
};

function mapStateToProps(state) {
    return {
        partner: state.partner,
        payment: state.payment.data,
    };
}

export default connect(mapStateToProps)(PaymentDelayedDetails);



// WEBPACK FOOTER //
// ./safeTrade/seller/resolution/statusDetails/paymentDelayedDetails.jsx